import React, { useState, useEffect } from "react";
import { useForgotPasswordMutation } from "../../redux/api/userApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import {Image} from 'react-bootstrap';

export default function ForgotPassword() {
   const [email, setEmail] = useState("");

   const navigate = useNavigate();

   const [forgotPassword, { isLoading, error, isSuccess }] =
     useForgotPasswordMutation();

   const { isAuthenticated } = useSelector((state) => state.auth);

   useEffect(() => {
     if (isAuthenticated) {
       navigate("/");
     }
     if (error) {
       toast.error(error?.data?.message);
     }

     if (isSuccess) {
       toast.success("Email Sent. Please check your inbox");
     }
   }, [error, isAuthenticated, isSuccess, navigate]);

   const submitHandler = (e) => {
     e.preventDefault();
      forgotPassword({ email });
      };

      
  return (
    <div className="flex flex-wrap">
      <div className="w-full md:w-1/2 flex justify-center">
        <div className="recovery-image-section">
          <img
            src="/img/account_recovery.png"
            alt="Account Recovery"
            loading="lazy"
            className="max-w-full h-auto"
          />
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <section className="p-4">
          <form onSubmit={submitHandler} className="space-y-6">
            <Image
              src="/img/new_logo_grey.png"
              alt="Creatyea Technology"
              className="mx-auto"
            />
            <p className="text-center">
              Enter your email and we'll send you a link to get back into your
              account
            </p>
            <div className="relative">
              <input
                type="email"
                id="email_field"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input px-4 py-2 border border-gray-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder=" "
              />
              <label
                htmlFor="email_field"
                className="absolute left-4 -top-3.5 text-gray-500 text-sm bg-white px-1"
              >
                Email
              </label>
            </div>
            <button
              type="submit"
              name="button"
              className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {isLoading ? <i className="fas fa-spinner fa-spin"></i> : "Send"}
            </button>
          </form>
        </section>
        <br />
        <section className="text-center mt-4">
          <Link to="/login" className="text-blue-500 hover:text-blue-700">
            Back to Login
          </Link>
        </section>
      </div>
    </div>
  );
}
